import Vue from 'vue'
import Router from 'vue-router'
import global from '@/core/global/global'
var param = global.global.getParam();


Vue.use(Router)


import manage_routers from "./manage_routers"//登录注册

const originalPush = Router.prototype.push
Router.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject)
  // return originalPush.call(this, location).catch(err => err)
  return originalPush.call(this, location)
}

var projects = [
  manage_routers,
]

var routes = (branches) => {
  var merge = [];
  branches.map(function(item) {
    merge.push.apply(merge, item);
  })
  return merge;
}
var router = new Router({
  routes: routes(projects)
})


router.beforeEach((to, from, next) => {
  if(to.path=='/manage/mySubmission'){
    next()
  }else if(to.path=='/'){
      sessionStorage.clear()
      next({path: '/loginAdmin'})
      //window.location.href=global.global.url+`/logout?Authorization=${param.token}&prid=${param.prid}`;
  }else{
    next()
  }
  // else{
  //   if(session){
  //     next()
  //   }else{
  //     next({path: '/loginAdmin'})
  //   }
  // }

})
export default router;



// WEBPACK FOOTER //
// ./src/router/index.js